"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimaryProduct = exports.Level = exports.FeatureRoleType = void 0;
var FeatureRoleType;
(function (FeatureRoleType) {
    FeatureRoleType["BASE_PLATE"] = "BASE_PLATE";
    FeatureRoleType["USER_TYPE"] = "USER_TYPE";
    FeatureRoleType["PRODUCT_PLAN"] = "PRODUCT_PLAN";
    FeatureRoleType["ADD_ON"] = "ADD_ON";
    FeatureRoleType["GLOBAL"] = "GLOBAL";
})(FeatureRoleType = exports.FeatureRoleType || (exports.FeatureRoleType = {}));
var Level;
(function (Level) {
    Level["COMPANY"] = "COMPANY";
    Level["USER"] = "USER";
    Level["GLOBAL"] = "GLOBAL";
})(Level = exports.Level || (exports.Level = {}));
var PrimaryProduct;
(function (PrimaryProduct) {
    PrimaryProduct["MONITORING"] = "MONITORING";
    PrimaryProduct["BIDDING"] = "BIDDING";
    PrimaryProduct["ANALYTICS"] = "ANALYTICS";
    PrimaryProduct["OTHER"] = "OTHER";
})(PrimaryProduct = exports.PrimaryProduct || (exports.PrimaryProduct = {}));
